import React, { useEffect } from 'react'
import { useDropzone } from 'react-dropzone'
import { isEmpty } from 'lodash'
import promiseAllValues from '../../../../utils/promiseAllValues'
import { photoObject } from '../../../PhotoManager/functions'
import PhotoTile from '../../../PhotoManager/PhotoTile'
import useModuleInit from '../../../../utils/newforms/changed/useModuleInit'
import { base64ToFile } from '../../../../utils/files/base64ToFile'
import '../../../PhotoManager/PhotoManager.sass'
import './SingleSeoImageManager.sass'

/**
 * Single-image adapter for SEO OG fields.
 * Local state: 0..1 photo objects (may include needUpload/file).
 * Does not write to Firestore or Storage — parent save owns persistence.
 */
function SingleSeoImageManager({ formData, syncState, helperText }) {
  const [photos, setPhotos] = useModuleInit({
    formData: formData ? [formData] : [],
    initialState: [],
  })

  useEffect(() => {
    const next = photos[0] || null
    syncState(next)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos])

  const onDrop = (acceptedFiles) => {
    if (isEmpty(acceptedFiles)) return
    const file = acceptedFiles[0]
    promiseAllValues(
      new photoObject({
        file,
        isAvatar: true,
      })
    ).then((photo) => setPhotos([photo]))
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    multiple: false,
    accept: 'image/*',
  })

  const onImageEdited = (newDataUrl) => {
    if (isEmpty(photos)) return
    const photo = { ...photos[0] }
    photo.file = base64ToFile(newDataUrl, photo.fileName)
    photo.needUpload = true
    photo.imageUrl = newDataUrl
    setPhotos([photo])
  }

  const onDelete = () => setPhotos([])

  return (
    <div className="SingleSeoImageManager PhotoManager">
      {helperText ? <p className="SingleSeoImageManager-Helper">{helperText}</p> : null}
      {!isEmpty(photos) && (
        <div className="PhotoManager-PhotoGrid SingleSeoImageManager-Grid">
          <PhotoTile
            {...photos[0]}
            setAvatar={() => null}
            onDelete={onDelete}
            onEdit={onImageEdited}
          />
        </div>
      )}
      {isEmpty(photos) && (
        <div className={['DragAndDrop-Zone'].join(' ')} {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Перетягніть зображення сюди…</p>
          ) : (
            <p>
              Перетягніть одне зображення для OG, або <span>натисніть тут</span> для вибору
            </p>
          )}
        </div>
      )}
      {!isEmpty(photos) && (
        <button type="button" className="SingleSeoImageManager-Replace" {...getRootProps()}>
          <input {...getInputProps()} />
          Замінити зображення
        </button>
      )}
    </div>
  )
}

export default SingleSeoImageManager
